
  import { computed, defineComponent, PropType } from 'vue';
  import { Colour, getFeatureColourFromBackground, getForegroundColourFromBackground } from '../../../helpers/colour';
  import TpxContentBlock from '../content/content-block.vue';
  import TpxIcon from '../../atoms/icon/icon.vue';
  import TpxImage from '../../atoms/media/image.vue';
  import TpxInlineList from '../../atoms/list/inline-list.vue';
  import TpxParagraph from '../../atoms/type/paragraph.vue';
  import './listing-item.scss';

  /**
   * Image effect on hover
   * @enum {string}
   */
  export enum ListingImageHoverEffect {
    None = 'none',
    Circular = 'circle',
    Random = 'random',
    TiltBackwards = 'tilt-back',
    TiltForwards = 'tilt-forward',
  }

  const randomImageHoverEffectOptions: ListingImageHoverEffect[] = [
    ListingImageHoverEffect.Circular,
    ListingImageHoverEffect.TiltBackwards,
    ListingImageHoverEffect.TiltForwards,
  ];

  /**
   * List item to be displayed within TpxList
   * 
   * @example
   * <code>import TpxListingItem from '@manifesto-tech/tpximpact-design-system/components/molecules/listing/listing-item.vue'</code>
   */
  export default defineComponent({
    name: 'TpxListingItem',

    components: {
      TpxContentBlock,
      TpxIcon,
      TpxImage,
      TpxInlineList,
      TpxParagraph,
    },

    props: {
      /**
       * Background colour
       */
      backgroundColour: {
        default: Colour.White,
        type: String,
        validator: (value) => {
          return Object.values(Colour).includes(value as Colour);
        },
      },

      /**
       * Optional client name for projects
       */
      client: {
        type: Object,
      },

      /**
       * Optional copy to display below the heading
       */
      copy: {
        type: String,
      },

      /**
       * List of details to display below the content, such as author or read times
       */
      details: {
        type: Array,
      },

      /**
       * Content Type
       */
       type: {
        type: String,
      },

      /**
       * Heading
       */
      heading: {
        required: true,
        type: String,
      },

      /**
       * Link to item page
       */
      href: {
        required: true,
        type: String,
      },

      /**
       * Image object
       */
      image: {
        type: Object as PropType<typeof TpxImage>,
      },

      /**
       * Show the image on hover (desktop only)
       * If left blank this effect would be disabled
       */
      imageHoverEffect: {
        type: String,
        validator: (value) => {
          return Object.values(ListingImageHoverEffect).includes(value as ListingImageHoverEffect);
        },
      },

      /**
       * Show arrow on hover?
       */
      showArrowOnHover: {
        default: false,
        type: Boolean,
      },
    },

    data() {
      return {
        classes: computed(() => ({
          ['m-listing-item--show-image-on-hover']: !!this.imageHoverEffect,
        })),
        imageClasses: computed(() => ({
          [`m-listing-item__image--${this.imageHoverEffect as unknown as ListingImageHoverEffect == ListingImageHoverEffect.Random
            ? randomImageHoverEffectOptions[Math.floor(Math.random() * randomImageHoverEffectOptions.length)]
            : this.imageHoverEffect}`]: !!this.imageHoverEffect,
        })),
      };
    }
  });
